import React, { Suspense } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  IconButton,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useModerationApi } from "./hooks/useModerationApi";
import { ConfigurationTabs } from "./ConfigurationTabs";

interface ConfigurationContentProps {
  onBack: () => void;
}

const ConfigurationContent: React.FC<ConfigurationContentProps> = ({ onBack }) => {
  const api = useModerationApi();

  const handleRefresh = () => {
    api.refreshConfig();
    api.refreshBlocklist();
    api.refreshAllowlist();
  };

  return (
    <>
      <Box sx={{ display: "flex", gap: 2, mb: 2, alignItems: "center" }}>
        <IconButton
          onClick={onBack}
          color="primary"
          sx={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}
          title="Back to Moderation"
        >
          <ArrowBackIcon />
        </IconButton>
      </Box>

      <ConfigurationTabs onRefresh={handleRefresh} />
    </>
  );
};

interface ConfigurationPageProps {
  onBack?: () => void;
}

export const ConfigurationPage: React.FC<ConfigurationPageProps> = ({ onBack }) => {
  const defaultOnBack = () => {
    if (typeof window !== "undefined" && window.localStorage) {
      localStorage.setItem("activeScreenId", "moderation");
      window.location.reload();
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Moderation Configuration
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Configure moderation thresholds, blocklist, and allowlist
      </Typography>
      <Box sx={{ mt: 3 }}>
        <Suspense
          fallback={
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: 400,
              }}
            >
              <CircularProgress />
            </Box>
          }
        >
          <ConfigurationContent onBack={onBack || defaultOnBack} />
        </Suspense>
      </Box>
    </Box>
  );
};
